import {
    CONSUMPTION_DEVICES_REQUEST,
    CONSUMPTION_DEVICES_SUCCESS,
    CONSUMPTION_DEVICES_FAILURE,
    CONSUMPTION_DATA_REQUEST,
    CONSUMPTION_DATA_SUCCESS,
    CONSUMPTION_DATA_FAILURE,
    CONSUMPTION_FILTER_APPLY,
    CONSUMPTION_RESET
} from "./ActionTypes";

const createInitialState = () => ({
    devices: {
		items: [],
		loading: false,
		error: null,
		requestId: null,
		objectId: null
	},

    chart: {
        items: [],
        loading: false,
        error: null,
        failedDeviceIds: [],
        requestId: null
    },

    appliedFilter: {
        dateFrom: null,
        dateTo: null,
        groupBy: "day",
        selectedDeviceIds: []
    },

    hasAppliedFilter: false
});

const initialState = createInitialState();

const ConsumptionReducer = (
    state = initialState,
    action
) => {
    switch (action.type) {
        case CONSUMPTION_DEVICES_REQUEST:
            return {
                ...state,

                devices: {
					items: [],
					loading: true,
					error: null,
					requestId: action.requestId,
					objectId: action.objectId
				}
            };

        case CONSUMPTION_DEVICES_SUCCESS:
            // Не принимаем результат устаревшего запроса.
            if (
                state.devices.requestId !==
                action.requestId
            ) {
                return state;
            }

            return {
                ...state,

                devices: {
					items: action.items || [],
					loading: false,
					error: null,
					requestId: action.requestId,
					objectId: state.devices.objectId
				}
            };

        case CONSUMPTION_DEVICES_FAILURE:
            // Ошибка могла прийти от уже устаревшего запроса.
            if (
                state.devices.requestId !==
                action.requestId
            ) {
                return state;
            }

            return {
                ...state,

                devices: {
					items: [],
					loading: false,

					error:
						action.error ||
						"Не удалось загрузить устройства",

					requestId: action.requestId,
					objectId: state.devices.objectId
				}
            };

        case CONSUMPTION_FILTER_APPLY:
            return {
                ...state,

                appliedFilter: {
                    ...state.appliedFilter,
                    ...action.filter,

                    selectedDeviceIds:
                        action.filter &&
                        action.filter.selectedDeviceIds
                            ? [
                                ...action.filter
                                    .selectedDeviceIds
                            ]
                            : []
                },

                hasAppliedFilter: true
            };

        case CONSUMPTION_DATA_REQUEST:
            return {
                ...state,

                chart: {
                    items: [],
                    loading: true,
                    error: null,
                    failedDeviceIds: [],
                    requestId: action.requestId
                }
            };

        case CONSUMPTION_DATA_SUCCESS:
            // Пользователь мог применить новый фильтр,
            // пока предыдущий запрос ещё выполнялся.
            if (
                state.chart.requestId !==
                action.requestId
            ) {
                return state;
            }

            return {
                ...state,

                chart: {
                    items: action.items || [],
                    loading: false,
                    error: null,
                    failedDeviceIds:
                        action.failedDeviceIds || [],
                    requestId: action.requestId
                }
            };

        case CONSUMPTION_DATA_FAILURE:
            if (
                state.chart.requestId !==
                action.requestId
            ) {
                return state;
            }

            return {
                ...state,

                chart: {
                    items: [],
                    loading: false,
                    error:
                        action.error ||
                        "Не удалось загрузить данные расхода",
                    failedDeviceIds:
                        action.failedDeviceIds || [],
                    requestId: action.requestId
                }
            };

        case CONSUMPTION_RESET:
            return createInitialState();

        default:
            return state;
    }
};

export default ConsumptionReducer;